/* eslint-disable */
import React, { useState } from "react";

import {
  Divider,
  Group,
  Stack,
  Text,
  Title,
  Avatar,
  Badge,
  Paper,
  Grid,
  Card,
  ActionIcon,
  Anchor,
  ScrollArea,
  MediaQuery,
  Box,
  Container,
  Button,
  Tooltip, // <-- added
} from "@mantine/core";
import {
  Building,
  Calendar,
  Clock,
  Details,
  Edit,
  List,
  Mail,
  MapPin,
  Message,
  Minus,
  Phone,
  Trash,
  Users,
} from "tabler-icons-react";
import { useGetUser } from "api/users/getUser";
import DOMPurify from "dompurify";
import NotFound from "components/NotFound";
import { getInitials } from "utils/getInitials";
import { Project, User } from "types";
import { formatDateToDDMMYYYY } from "utils/dateFormate";
import { capitalizeFirstLetter } from "utils/capitalizeFirstLetter";
import { useGetProjects } from "api/projects/getProjects";
import { Link, useNavigate, useParams } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { useGetUserProfile } from "api/users/getUserProfile";
import { set } from "zod";
import UpdateUserProfileModal from "../updateuserProfile";
import { useGetDepartments } from "api/department/getAllDepartment";
import { IconSitemap } from "@tabler/icons-react";
import { PermissionActionIcon } from "api/permission/permissionActionBtn";
import { useExportUserPDF } from "api/users/getUserPdf";
import { useEmploymentHistory } from "api/users/getEmployementHistory";
import { useDeleteEmploymentHistory } from "api/users/deleteEmploymentHistory";
import HiringModal from "../hiringDetail";
import AddHiringModal from "../hiringDetail/addHiring";
import { useHasPermission } from "api/permission/useHasPermission";
import { useGetOrg } from "api/organizations/getOrg";
import { textOverlap } from "utils/commonFunction";
import { useGetUserPrograms } from "api/program/getUserPrograms";
import { Loader } from "@mantine/core";

const statusColorMap: Record<string, string> = {
  inProgress: "yellow",
  inReview: "red",
  todo: "blue",
};

type Task = {
  _id: string;
  title: string;
  description?: string;
  projectName: string;
  project: string;
};

function UserProfile() {
  const { userid } = useParams();
  const [opened, setOpened] = useState(false);
  const [openedHiringUpdate, setHiringUpdateOpened] = useState(false);
  const [entryId, setEntryId] = useState<string | undefined>(undefined);

  const [addHiringOpened, setAddHiringOpened] = useState(false);
  const navigate = useNavigate();

  const { mutate: exportUserPDF, isLoading: exporting } = useExportUserPDF();
  const { data: employmenthistory } = useEmploymentHistory(userid!);
  const deleteEmploymentHistoryMutation = useDeleteEmploymentHistory();
  const {
    data: user,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetUserProfile(userid);
  const { data: programsData, isLoading: programsLoading } = useGetUserPrograms(userid ?? null);

  // Permission checks for employment history operations
  const { has: canAddEmploymentHistory } = useHasPermission("employment_history.add");
  const { has: canUpdateEmploymentHistory } = useHasPermission("employment_history.update");
  const { has: canDeleteEmploymentHistory } = useHasPermission("employment_history.delete");

  console.log("user dashboard", user);
  const typedUser = user as User | null | any;
  const {
    data = {
      projects: [],
      createdIssuesLast7Days: [],
      completedIssuesLast7Days: [],
    },
  } = useGetProjects(typedUser?.org?._id, typedUser?._id ?? "");

  const getUserTasksByStatus = (projects: Project[], userId: string) => {
    const groupedTasks = {
      todo: [] as Task[],
      inProgress: [] as Task[],
      inReview: [] as Task[],
    };

    projects.forEach((project) => {
      project.todoIssues?.forEach((issue) => {
        if (issue.assignee === userId) {
          groupedTasks.todo.push({ ...issue, projectName: project.name });
        }
      });

      project.inProgressIssues?.forEach((issue) => {
        if (issue.assignee === userId) {
          groupedTasks.inProgress.push({ ...issue, projectName: project.name });
        }
      });

      project.inReviewIssues?.forEach((issue) => {
        if (issue.assignee === userId) {
          groupedTasks.inReview.push({ ...issue, projectName: project.name });
        }
      });
    });

    return groupedTasks;
  };

  function arrayBufferToBase64(buffer: ArrayBuffer | Uint8Array) {
    const bytes =
      buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    let binary = "";
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) binary += String.fromCharCode(bytes[i]);
    return window.btoa(binary);
  }

  function getProfileImageSrc(user: any) {
    if (!user) return undefined;

    const img = user.profileImage;
    if (!img) return undefined;

    if (typeof img === "string") {
      // Check if it's a URL
      if (img.startsWith("http://") || img.startsWith("https://")) {
        return img;
      }
      // Check if it's already a data URI
      if (img.startsWith("data:")) return img;
      // Assume it's base64
      return `data:image/png;base64,${img}`;
    }

    if (typeof img === "object") {
      const contentType = img.contentType || img.mimetype || "image/png";
      const data = img.data ?? img.buffer ?? img;
      if (!data) return undefined;

      if (typeof data === "string") return `data:${contentType};base64,${data}`;

      try {
        const b64 = arrayBufferToBase64(data);
        return `data:${contentType};base64,${b64}`;
      } catch (e) {
        return undefined;
      }
    }

    return undefined;
  }

  const taskData =
    getUserTasksByStatus(data.projects, typedUser?._id ?? "") ?? [];
  const countOfTotalTask =
    taskData.inProgress.length +
    taskData.inReview.length +
    taskData.todo.length;
  const getUserIssueCounts = (projects: Project[], userId: string) => {
    const counts = {
      todo: 0,
      inProgress: 0,
      inReview: 0,
      done: 0,
    };

    projects.forEach((project) => {
      counts.todo += project.todoIssues.filter(
        (issue) => issue.assignee === userId
      ).length;
      counts.inProgress += project.inProgressIssues.filter(
        (issue) => issue.assignee === userId
      ).length;
      counts.inReview += project.inReviewIssues.filter(
        (issue) => issue.assignee === userId
      ).length;
      counts.done += project.completedIssues.filter(
        (issue) => issue.assignee === userId
      ).length;
    });

    return counts;
  };

  if (isLoading || !typedUser) {
    return <h1>loading....</h1>;
  }

  if (isError) {
    return <NotFound />;
  }

  const exportPayload = {
    fields: {
      // Basic Information
      firstName: true,
      lastName: true,
      email: true,
      role: true,
      position: true,
      status: true,
      description: true,
      profileImage: true,
      inactiveReason: true,

      // Organization
      organization: true,
      department: true,
      treatyNo: true,

      // Contact Information
      phoneNumber: true,
      corporateEmail: true,
      corporatePhone: true,
      address: true,
      personalEmail: true,
      personalPhone: true,
      homeAddress: true,

      // Employment Details
      employmentType: true,
      employmentCategory: true,
      startDate: true,
      endDate: true,
      consecutiveYearsOfService: true,
      reportingManager: true,

      // Personal Information
      nationality: true,
      dateOfBirth: true,
      passportNo: true,
      emergencyContact: true,

      // Bank Information
      bankName: true,
      accountNo: true,

      // History & Salary
      employmentHistory: true,
      salaryAmount: true,
      salary: true,

      // Working Hours
      workingHours: true,
      workingHoursConfig: true,
    },
  };

  // Helper accessors for employment history response shape
  const employmentEntries =
    employmenthistory?.data?.employmentHistory ??
    employmenthistory?.data?.employmentHistory ??
    [];
  const consecutiveYearsOfService =
    employmenthistory?.data?.consecutiveYearsOfService ??
    employmenthistory?.data?.consecutiveYearsOfService;

  return (
    <>
      <Title order={3} mb="md" size={18}>
        {`${typedUser?.firstName}
                  ${typedUser?.lastName}`}{" "}
        Detail Profile
      </Title>

      <Grid gutter="md" grow>
        <Grid.Col span={8}>
          <Stack spacing="md">
            <Card shadow="sm" radius="md" withBorder>
              <Group spacing="md" align="flex-start">
                <Avatar
                  size={80}
                  radius="xl"
                  src={getProfileImageSrc(typedUser)}
                  alt={`${typedUser?.firstName ?? ""} ${
                    typedUser?.lastName ?? ""
                  }`}
                >
                  {getInitials(
                    typedUser?.firstName ?? "",
                    typedUser?.lastName ?? ""
                  )}
                </Avatar>

                <Box style={{ flex: 1 }}>
                  <Title order={3} mb={4} size={18}>
                    {typedUser?.org?.name}
                  </Title>
                  <Text size="sm" color="dimmed" mb={8}>
                    {`${typedUser?.firstName} ${typedUser?.lastName}`}
                  </Text>
                  <Text
                    size="sm"
                    color="dimmed"
                    lineClamp={3}
                    style={{ maxWidth: "92%" }}
                  >
                    {textOverlap(typedUser?.description ?? "N/A", 150)}
                  </Text>

                  <Grid mt="md">
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Phone size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Phone Number</Text>
                          <Text size="sm">{typedUser?.personalInfo?.phoneNumber ?? "N/A"}</Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Mail size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Corporate Email</Text>
                          <Text size="sm">{user?.email ?? "NA"}</Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <IconSitemap size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Department</Text>
                          <Text size="sm">{typedUser?.department?.name ?? "N/A"}</Text>
                        </div>
                      </Group>
                    </Grid.Col>

                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Calendar size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Date of Birth</Text>
                          <Text size="sm" className="w-[70%]">
                            {typedUser?.personalInfo?.dateOfBirth &&
                              formatDateToDDMMYYYY(
                                typedUser?.personalInfo?.dateOfBirth?.toString()
                              )}
                          </Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Calendar size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Start Date</Text>
                          <Text size="sm" className="w-[70%]">
                            {typedUser?.startDate
                              ? formatDateToDDMMYYYY(
                                  typedUser?.startDate?.toString()
                                )
                              : "N/A"}
                          </Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Calendar size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Employee Status</Text>
                          <Text size="sm">
                            {(typedUser as any)?.serviceStatus ?? "Employed"}
                          </Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Clock size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Working Hours</Text>
                          <Text size="sm">
                            {(() => {
                              const config = (typedUser as any)?.resolvedWorkingHours?.config;
                              const startTime = config?.startTime;
                              const endTime = config?.endTime;

                              return startTime && endTime ? (
                                <>
                                  {startTime} {" - "} {endTime}
                                </>
                              ) : (
                                "N/A"
                              );
                            })()}
                          </Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={12} lg={12}>
                      <Group spacing="xs">
                        <MapPin size={16} />
                        <div className="flex flex-col">
                          <Text size="xs" color="dimmed">Address</Text>
                          <Text size="sm">{typedUser?.personalInfo?.address ?? "NA"}</Text>
                        </div>
                      </Group>
                    </Grid.Col>
                    <Grid.Col md={6} lg={6}>
                      <Group spacing="xs">
                        <Text size="sm" weight={500}>
                          Login PIN:
                        </Text>
                        <Text size="sm">
                          {typedUser?.loginPin ?? "N/A"}
                        </Text>
                      </Group>
                    </Grid.Col>
                  </Grid>
                </Box>

                <Group style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    size="xs"
                    variant="outline"
                    onClick={() =>
                      exportUserPDF({
                        userId: userid ?? "",
                        payload: exportPayload,
                      })
                    }
                    loading={exporting}
                    aria-label="Export user PDF"
                  >
                    Export
                  </Button>

                  <ActionIcon
                    // style={{ cursor: "not-allowed" }}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                    onClick={() => {
                      setOpened(true);
                    }}
                  >
                    <Edit size={20} />
                  </ActionIcon>
                </Group>
              </Group>

              <Divider my="md" />

              <Group position="apart" align="center">
                <Text weight={500}>{typedUser?.position}</Text>
                <Text size="sm" color="dimmed">
                  Employee Id : 00001
                </Text>
              </Group>
            </Card>
            {/* Emergency Contact Details Card */}

            {/* Current Work Project Card */}
            {/* <Card shadow="sm" radius="md" withBorder>
              <Title order={4} mb="md" size={18}>
                Current Work Project
              </Title>

              <Grid>
                {data?.projects.map((project) => {
                  const counts = getUserIssueCounts(
                    [project],
                    typedUser?._id ?? ""
                  );
                  return (
                    <Grid.Col span={6} key={project._id}>
                      <Paper radius="md">
                        <Card shadow="xs" radius="md" withBorder>
                          <Group position="apart" mb="xs">
                            <Anchor
                              component={Link}
                              to={`/projects/${project._id}`}
                              color="dark.4"
                              size={16}
                              weight={600}
                            >
                              <Text weight={500} size="sm" lineClamp={1}>
                                {project.name}
                              </Text>
                            </Anchor>
                          </Group>

                          <Group spacing="md" mb="md">
                            <Details size={14} />
                            <Group spacing="xs">
                              <Text size="xs">{counts?.todo} Todo</Text>
                            </Group>
                            <Group spacing="xs">
                              <Text size="xs">
                                {counts?.inProgress} In Progress
                              </Text>
                            </Group>
                            <Group spacing="xs">
                              <Text size="xs">
                                {counts?.inReview} In Review
                              </Text>
                            </Group>
                            <Group spacing="xs">
                              <Text size="xs">{counts?.done} Done</Text>
                            </Group>
                          </Group>
                        </Card>
                      </Paper>
                    </Grid.Col>
                  );
                })}
              </Grid>
            </Card> */}

            <Card shadow="sm" radius="md" withBorder>
              <Group position="apart" align="center" mb="md">
                <Title order={4} size={18}>
                  Employment History
                </Title>
                <Tooltip
                  label={!canAddEmploymentHistory ? "You don't have permission to add employment history" : "Add new employment history entry"}
                  withArrow
                  disabled={canAddEmploymentHistory}
                >
                  <div>
                    <Button
                      size="xs"
                      variant="outline"
                      disabled={!canAddEmploymentHistory}
                      onClick={() => {
                        if (canAddEmploymentHistory) {
                          setAddHiringOpened(true);
                        }
                      }}
                    >
                      Add Employment History
                    </Button>
                  </div>
                </Tooltip>
              </Group>

              <Grid>
                {employmentEntries && employmentEntries.length > 0 ? (
                  employmentEntries.map((entry, idx) => {
                    const key = entry._id ?? `employment-${idx}`;

                    const start = entry.startDate
                      ? formatDateToDDMMYYYY(entry.startDate?.toString())
                      : "N/A";
                    const end = entry.endDate
                      ? formatDateToDDMMYYYY(entry.endDate?.toString())
                      : "Present";

                    const salaryAmount =
                      entry.salaryAmount !== undefined &&
                      entry.salaryAmount !== null
                        ? String(entry.salaryAmount)
                        : "N/A";

                    const currency = entry.currency ?? "N/A";
                    const salaryType = entry.salaryType ?? "N/A";
                    const position = entry.position ?? "N/A";

                    // Check if this is the active employment (no endDate)
                    const isActive = !entry.endDate;

                    return (
                      <Grid.Col span={6} key={key}>
                        <Paper radius="md">
                          <Card
                            shadow={isActive ? "md" : "xs"}
                            radius="md"
                            withBorder
                            style={{
                              width: "100%",
                              height: "24vh",
                              borderColor: isActive ? "#4c6ef5" : undefined,
                              borderWidth: isActive ? 2 : 1,
                              backgroundColor: isActive ? "#f8f9ff" : undefined,
                            }}
                          >
                            <Group position="apart" mb="xs">
                              <Group spacing="xs">
                                <Tooltip label={position} withArrow>
                                  <Text weight={600} size="sm" lineClamp={1}>
                                    {textOverlap(position, 10)}
                                  </Text>
                                </Tooltip>
                                {isActive && (
                                  <Badge
                                    color="green"
                                    size="sm"
                                    variant="filled"
                                  >
                                    Active
                                  </Badge>
                                )}
                              </Group>
                              <Group spacing="xs">
                                <Tooltip
                                  label={!canUpdateEmploymentHistory ? "You don't have permission to update employment history" : "Edit employment history"}
                                  withArrow
                                  disabled={canUpdateEmploymentHistory}
                                >
                                  <ActionIcon
                                    disabled={!canUpdateEmploymentHistory}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                    onClick={() => {
                                      if (canUpdateEmploymentHistory) {
                                        setEntryId(entry._id);
                                        setHiringUpdateOpened(true);
                                      }
                                    }}
                                  >
                                    <Edit size={20} />
                                  </ActionIcon>
                                </Tooltip>
                                <Tooltip
                                  label={!canDeleteEmploymentHistory ? "You don't have permission to delete employment history" : "Delete employment history"}
                                  withArrow
                                  disabled={canDeleteEmploymentHistory}
                                >
                                  <ActionIcon
                                    disabled={!canDeleteEmploymentHistory || deleteEmploymentHistoryMutation.isLoading}
                                    color="red"
                                    loading={deleteEmploymentHistoryMutation.isLoading}
                                    onClick={() => {
                                      if (canDeleteEmploymentHistory && userid && entry._id) {
                                        if (window.confirm("Are you sure you want to delete this employment history entry?")) {
                                          deleteEmploymentHistoryMutation.mutate({
                                            userId: userid,
                                            entryId: entry._id,
                                          });
                                        }
                                      }
                                    }}
                                  >
                                    <Trash size={20} />
                                  </ActionIcon>
                                </Tooltip>
                              </Group>
                            </Group>

                            <Group spacing="xs" mb="xs" align="center">
                              <Calendar size={14} />
                              <Text size="xs">
                                <Text component="span" weight={600}>
                                  {isActive ? "Start Date:" : "Dates:"}
                                </Text>{" "}
                                <Text
                                  component="span"
                                  color={isActive ? "blue" : undefined}
                                  weight={isActive ? 600 : undefined}
                                >
                                  {isActive ? start : `${start} - ${end}`}
                                </Text>
                              </Text>
                            </Group>

                            {/* {!isActive && (
                              <Group spacing="xs" mb="xs" align="center">
                                <Calendar size={14} />
                                <Text size="xs">
                                  <Text component="span" weight={600}>
                                    End Date:
                                  </Text>{" "}
                                  <Text component="span">
                                    {end}
                                  </Text>
                                </Text>
                              </Group>
                            )} */}

                            <Group spacing="xs" mb="md" align="center">
                              <Text size="xs">
                                <Text component="span" weight={600}>
                                  Salary:
                                </Text>{" "}
                                <Text component="span">{salaryAmount}</Text>
                              </Text>

                              <Text size="xs">
                                <Text component="span" weight={600}>
                                  Currency:
                                </Text>{" "}
                                <Text component="span">{currency}</Text>
                              </Text>

                              <Text size="xs">
                                <Text component="span" weight={600}>
                                  Salary Type:
                                </Text>{" "}
                                <Text
                                  component="span"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {salaryType}
                                </Text>
                              </Text>
                            </Group>
                          </Card>
                        </Paper>
                      </Grid.Col>
                    );
                  })
                ) : (
                  <Grid.Col span={12}>
                    <Text size="sm" color="dimmed">
                      No employment history found.
                    </Text>
                  </Grid.Col>
                )}
              </Grid>
            </Card>
          </Stack>
        </Grid.Col>
        <Grid.Col span={4}>
          <Card shadow="sm" radius="md" withBorder>
            <Title order={4} mb="md" size={18}>
              Programs
            </Title>

            {programsLoading ? (
              <Group position="center" py="md">
                <Loader size="xs" />
              </Group>
            ) : programsData?.data && programsData.data.length > 0 ? (
              <Stack spacing="xs">
                {programsData.data.map((program) => (
                  <Badge key={program._id} size="lg" variant="light" fullWidth>
                    {program.name}
                  </Badge>
                ))}
              </Stack>
            ) : (
              <Text size="sm" color="dimmed">
                No programs assigned
              </Text>
            )}
          </Card>

          {typedUser?.personalInfo?.emergencyContact && (
            <Card shadow="sm" radius="md" withBorder mt="md">
              <Title order={4} mb="md" size={18}>
                Emergency Contact Details
              </Title>

              <Group spacing="xs">
                <Users size={16} />
                <Tooltip
                  label={typedUser.personalInfo.emergencyContact.name || "N/A"}
                  withArrow
                >
                  <Text weight={600} size="sm" lineClamp={1}>
                    {textOverlap(
                      typedUser.personalInfo.emergencyContact.name || "N/A",
                      25
                    )}
                  </Text>
                </Tooltip>
              </Group>

              <Group spacing="xs" display={"flex"} style={{ display: "flex" }}>
                <Mail size={16} />
                <Text size="sm" style={{ maxWidth: "80%" }}>
                  {typedUser.personalInfo.emergencyContact.email || "N/A"}
                </Text>
              </Group>

              <Group spacing="xs">
                <Phone size={16} />
                <Text size="sm">
                  {typedUser.personalInfo.emergencyContact.phoneNumber || "N/A"}
                </Text>
              </Group>

              <Group spacing="xs" style={{ display: "flex" }}>
                <MapPin size={16} />
                <Text size="sm" style={{ maxWidth: "80%" }}>
                  {typedUser.personalInfo.emergencyContact.address || "N/A"}
                </Text>
              </Group>
            </Card>
          )}
        </Grid.Col>
        {/* Right Column */}
        <Grid.Col span={4}>
          {/* <Stack spacing="md">
            <Card shadow="sm" radius="md" withBorder>
              <Title order={4} mb="md" size={18}>
                {`Current Task (${countOfTotalTask})`}
              </Title>
              <ScrollArea style={{ height: "calc(88vh - 13rem)" }}>
                <Stack spacing="xs">
                  {(["todo", "inProgress", "inReview"] as const).map(
                    (statusKey) => {
                      const tasks = taskData[statusKey] ?? [];
                      return tasks.map((task) => (
                        <Card key={task._id} shadow="xs" radius="md" withBorder>
                          <Box>
                            <Group position="apart" mb="xs" noWrap>
                              <Text
                                size="sm"
                                weight={500}
                                lineClamp={1}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate(
                                    `/projects/${task.project}?selectedIssue=${task._id}`
                                  );
                                }}
                              >
                                {task.title}
                              </Text>
                              <Badge
                                color={statusColorMap[statusKey] || "gray"}
                                size="xs"
                              >
                                {statusKey.replace(/([A-Z])/g, " $1")}
                              </Badge>
                            </Group>
                            <Text
                              size="xs"
                              color="dimmed"
                              mb="xs"
                              lineClamp={2}
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  task?.description ?? "No description"
                                ) as string,
                              }}
                            />
                            <Badge size="xs" color="purple">
                              {task.projectName}
                            </Badge>
                          </Box>
                        </Card>
                      ));
                    }
                  )}
                </Stack>
              </ScrollArea>
            </Card>
          </Stack> */}
        </Grid.Col>
        <UpdateUserProfileModal
          // user={user ?? undefined}
          opened={opened}
          onClose={() => setOpened(false)}
          userId={userid}
        />
        <HiringModal
          opened={openedHiringUpdate}
          entryId={entryId}
          onClose={() => setHiringUpdateOpened(false)}
        />
        <AddHiringModal
          opened={addHiringOpened}
          onClose={() => setAddHiringOpened(false)}
        />
      </Grid>
    </>
  );
}

export default UserProfile;
